import { observer } from 'mobx-react-lite';

import DateRangePicker from '~components/Filters/DateRangePicker';
import { useStores } from '~store/RootStore';

export const DriverDayDateFilter = observer(function () {
  const { driverDayStore } = useStores();

  return (
    <DateRangePicker
      allowAllDates
      endDate={driverDayStore.dateFilters.endDate}
      mode="icon"
      onDateSelect={(startDate, endDate) => {
        driverDayStore.setDateFilters(startDate, endDate);
      }}
      showShortcuts
      startDate={driverDayStore.dateFilters.startDate}
      useTodayFormat
    />
  );
});
